import React from "react";
import Piecontent from "./section1/piecontent";
import Tablecontent from "./section2/tablecontent";

const Liveholdings = (props) => {
  return (
    <div className="row">
      <Piecontent newPieData={props.newPieData} />
      <Tablecontent newData={props.newData} tableHeading={props.tableHeading} />
    </div>
  );
};
export default Liveholdings;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/LiveHoldings/liveholdings.jsx